import clsx from "clsx"
import { HtmlHTMLAttributes } from "react"



export const ScreenWrapper = ({children, className, ...rest}: HtmlHTMLAttributes<HTMLDivElement>) => {
    return (
        <div className={clsx(className, "max-w-screen-2lg mr-auto ml-auto")} {...rest}>
            {children}
        </div>
    )


}